function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../icon/Icon';
import * as constants from './constants';
import { calculateTextProperties, generateInitials } from './util';
import { COLORS_PROP_TYPE } from '../color/constants';
import { ICON_TYPE_PROP_TYPE } from '../icon/constants';
import GREYS_JSON from '../color/color_greys.json';
import { Initials } from './_internals/Initials';
import { Image } from './_internals/Image';

var MainContent = function MainContent(_ref) {
  var text = _ref.text,
      maxChars = _ref.maxChars,
      textColor = _ref.textColor,
      numericSize = _ref.numericSize,
      iconType = _ref.iconType,
      iconColor = _ref.iconColor,
      size = _ref.size,
      imageUrl = _ref.imageUrl,
      x = _ref.x,
      y = _ref.y,
      fontSize = _ref.fontSize;
  var content = null; // Prioritize for images

  if (imageUrl) {
    content = React.createElement(Image, {
      imageUrl: imageUrl,
      size: numericSize
    });
  } else if (iconType) {
    // Use icon if no image is available. We need foreignObject to insert HTML into SVG
    content = React.createElement("foreignObject", {
      width: numericSize,
      height: numericSize
    }, React.createElement("div", {
      className: "eds-avatar__icon-container eds-align--center"
    }, React.createElement(Icon, {
      type: iconType,
      isBlockLevel: true,
      size: size,
      color: iconColor
    })));
  } else if (text) {
    // Use text/initials if no image or icon is available
    content = React.createElement(Initials, {
      x: x,
      y: y,
      fontSize: fontSize,
      textColor: textColor
    }, generateInitials(text, maxChars));
  }

  return content;
};

var Avatar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Avatar, _PureComponent);

  function Avatar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Avatar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Avatar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "_handleClick", function () {
      var onClick = _this.props.onClick;

      if (onClick) {
        onClick();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleMouseEnter", function () {
      var onHover = _this.props.onHover;

      if (onHover) {
        onHover(true);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleMouseLeave", function () {
      var onHover = _this.props.onHover;

      if (onHover) {
        onHover(false);
      }
    });

    return _this;
  }

  _createClass(Avatar, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          size = _this$props.size,
          backgroundColor = _this$props.backgroundColor,
          additionalProps = _objectWithoutProperties(_this$props, ["size", "backgroundColor"]); // translate semantic size to numeric size


      var numericSize = constants.AVATAR_SIZES[size];
      var textProperties = calculateTextProperties(numericSize); // Add border to avatars that use an image, have no background colour set, or have white background colour
      // See JIRA EB-83954

      var hasBorder = additionalProps.imageUrl || backgroundColor === 'white' || !backgroundColor;
      var backgroundClassName = classNames('eds-avatar__background', (_classNames = {}, _defineProperty(_classNames, "eds-bg-color--".concat(backgroundColor), backgroundColor), _defineProperty(_classNames, 'eds-avatar__background--has-border', hasBorder), _classNames));

      var mainContentProps = _objectSpread({}, additionalProps, textProperties, {
        size: size,
        numericSize: numericSize
      });

      return React.createElement("svg", {
        className: backgroundClassName,
        height: numericSize,
        width: numericSize,
        onClick: this._handleClick,
        onMouseEnter: this._handleMouseEnter,
        onMouseLeave: this._handleMouseLeave,
        "data-spec": "spec-avatar"
      }, React.createElement(MainContent, mainContentProps));
    }
  }]);

  return Avatar;
}(PureComponent);

_defineProperty(Avatar, "propTypes", {
  /**
   * The text used to generate the initials/abbreviation
   */
  text: PropTypes.string,

  /**
   * Size of the avatar xsmall, small, medium, large
   */
  size: PropTypes.oneOf(constants.SIZES),

  /**
   * Overrides the background color with any valid EDS color value
   */
  backgroundColor: COLORS_PROP_TYPE,

  /**
   * Overrides the text color with any EDS greyscale color value
   */
  textColor: PropTypes.oneOf(_toConsumableArray(Object.keys(GREYS_JSON))),

  /**
   * Type of icon to display in the Avatar
   */
  iconType: ICON_TYPE_PROP_TYPE,

  /**
   * Color of icon to display in the Avatar
   */
  iconColor: COLORS_PROP_TYPE,

  /**
   * Url for the image asset to display in the avatar
   */
  imageUrl: PropTypes.string,

  /**
   * callback to execute if the avatar is clicked
   */
  onClick: PropTypes.func,

  /**
   * callback to execute if the avatar is hovered
   */
  onHover: PropTypes.func,

  /**
   * optional prop to allow for more/less characters in the avatar
   */
  maxChars: PropTypes.number
});

_defineProperty(Avatar, "defaultProps", {
  size: 'medium',
  maxChars: 2
});

export { Avatar as default };